module.exports = __webpack_public_path__ + "static/rakshasa-dbd16959b3102e1cd4c97b4c82290882.jpeg";